// host
import { host } from '../../../../assets/constants/host'

export const apiGetTransHistoriesByUser = `${host}/backoffice/transactions-by-user`
export const apiExportExcelTransHistoriesByUser = `${host}/backoffice/export-trans-by-user`